/* eslint-disable */
var React = require('react');
var SpriteSymbol = require("../../../svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../svg-sprite-loader/runtime/browser-sprite.build.js");

var symbol = new SpriteSymbol({
  "id": "checkmark-circle-b604ac59--sprite",
  "use": "checkmark-circle-b604ac59--sprite-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"checkmark-circle-b604ac59--sprite\">\n  <g id=\"checkmark-circle-b604ac59--sprite_Group_7789\" data-name=\"Group 7789\" transform=\"translate(-150 -175)\">\n    <g id=\"checkmark-circle-b604ac59--sprite_Path_2126\" data-name=\"Path 2126\" transform=\"translate(150 175)\" fill=\"none\">\n      <path d=\"M9,0A9,9,0,1,1,0,9,9,9,0,0,1,9,0Z\" stroke=\"none\" />\n      <path d=\"M 9 2 C 5.140190124511719 2 2 5.140190124511719 2 9 C 2 12.85980987548828 5.140190124511719 16 9 16 C 12.85980987548828 16 16 12.85980987548828 16 9 C 16 5.140190124511719 12.85980987548828 2 9 2 M 9 0 C 13.97056007385254 0 18 4.029439926147461 18 9 C 18 13.97056007385254 13.97056007385254 18 9 18 C 4.029439926147461 18 0 13.97056007385254 0 9 C 0 4.029439926147461 4.029439926147461 0 9 0 Z\" stroke=\"none\" fill=\"currentColor\" />\n    </g>\n    <path id=\"checkmark-circle-b604ac59--sprite_Path_1936\" data-name=\"Path 1936\" d=\"M6016.952,421.336l2.186,1.727,3.168-5.278\" transform=\"translate(-5860.452 -236.285)\" fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-width=\"2\" />\n  </g>\n</symbol>"
});
sprite.add(symbol);

var SvgSpriteIcon = function SvgSpriteIcon(props) {
  return React.createElement(
    'svg',
    Object.assign({
      viewBox: symbol.viewBox
    }, props),
    React.createElement(
      'use',
      {
        xlinkHref: '#' + symbol.id
      }
    )
  );
};

SvgSpriteIcon.viewBox = symbol.viewBox;
SvgSpriteIcon.id = symbol.id;
SvgSpriteIcon.content = symbol.content;
SvgSpriteIcon.url = symbol.url;
SvgSpriteIcon.toString = symbol.toString;

module.exports = SvgSpriteIcon;
module.exports.default = SvgSpriteIcon;
